import { IconInfoCircle } from '@tabler/icons-react';
import BindReferralForm from '../BindReferralForm';
import ReferralCodeChip from './ReferralCodeChip';

export default function AccountReferralCards({
    referralCode,
    referredBy,
    referralsCount,
    totalEarned,
    copied,
    onCopyCode,
    onBindSuccess,
}) {
    return (
        <section className="account-page__section" aria-labelledby="account-referral-heading">
            <h3 id="account-referral-heading" className="account-page__section-label">
                Реферальная программа
            </h3>

            <div className="account-page__referral-cards">
                <div className="card account-page__referral-card">
                    <p className="account-page__card-title">Ваш код</p>
                    <p className="account-page__card-hint">
                        15% баллами с покупок приглашённых
                    </p>
                    <ReferralCodeChip
                        code={referralCode}
                        copied={copied}
                        onCopy={onCopyCode}
                    />
                    <div className="account-page__metric-grid">
                        <div className="account-page__metric">
                            <span className="account-page__metric-value">{referralsCount}</span>
                            <span className="account-page__metric-label">приглашённых</span>
                        </div>
                        <div className="account-page__metric">
                            <span className="account-page__metric-value">{totalEarned}</span>
                            <span className="account-page__metric-label">баллов заработано</span>
                        </div>
                    </div>
                </div>

                <div className="card account-page__referral-card">
                    <p className="account-page__card-title">Код друга</p>
                    {referredBy ? (
                        <>
                            <ReferralCodeChip
                                code={referredBy.code}
                                readonly
                            />
                            <span className="account-page__status-badge">
                                Привязан · 10% кэшбэк
                            </span>
                        </>
                    ) : (
                        <>
                            <p className="account-page__card-hint">
                                10% кэшбэк · привязка один раз
                            </p>
                            <BindReferralForm
                                onSuccess={onBindSuccess}
                                ownReferralCode={referralCode}
                            />
                        </>
                    )}
                </div>
            </div>

            <details className="account-page__referral-help">
                <summary className="account-page__referral-help-trigger">
                    <IconInfoCircle size={16} stroke={1.5} aria-hidden="true" />
                    Как работает
                </summary>
                <ul className="account-page__referral-help-list">
                    <li>Делитесь своим кодом — получайте 15% баллами с покупок приглашённых</li>
                    <li>Привяжите код друга один раз — 10% кэшбэк с ваших покупок</li>
                    <li>1 балл = 1 ₽</li>
                </ul>
            </details>
        </section>
    );
}
